import script from "./NotificationView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationView.vue?vue&type=script&setup=true&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=05c85f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c85f8c"]])

export default __exports__